"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var _require = require('../../commons'),
  getExpressPaymentMethods = _require.getExpressPaymentMethods;
var _require2 = require('../paymentMethods/index'),
  Paypal = _require2.Paypal,
  ApplePay = _require2.ApplePay,
  GooglePay = _require2.GooglePay,
  AmazonPay = _require2.AmazonPay;
var _require3 = require('../../../../../../config/constants'),
  APPLE_PAY = _require3.APPLE_PAY,
  GOOGLE_PAY = _require3.GOOGLE_PAY,
  PAYPAL = _require3.PAYPAL,
  AMAZON_PAY = _require3.AMAZON_PAY,
  PAY_WITH_GOOGLE = _require3.PAY_WITH_GOOGLE;
var store = require('../../../../../../config/store');
function hasEventListener(eventName) {
  var events = $._data($('body')[0], 'events');
  return events && events[eventName];
}
function getPaymentMethodConfig(adyenPaymentMethods, paymentMethodType) {
  var _adyenPaymentMethods$;
  return adyenPaymentMethods === null || adyenPaymentMethods === void 0 ? void 0 : (_adyenPaymentMethods$ = adyenPaymentMethods.paymentMethods.find(function (pm) {
    return paymentMethodType.indexOf(pm.type) > -1;
  })) === null || _adyenPaymentMethods$ === void 0 ? void 0 : _adyenPaymentMethods$.configuration;
}
function getExpressPaymentButtons(paymentMethodsResponse) {
  var cartExpressMethods = paymentMethodsResponse.cartExpressMethods;
  return cartExpressMethods.map(function (pm) {
    var $container = document.createElement('div');
    $container.setAttribute('id', "".concat(pm, "-container"));
    $container.setAttribute('class', "expressComponent ".concat(pm));
    $container.setAttribute('data-method', "".concat(pm));
    $container.setAttribute('style', "padding:0");
    return $container;
  });
}
function renderGooglePayButtonListener(_x, _x2) {
  return _renderGooglePayButtonListener.apply(this, arguments);
}
function _renderGooglePayButtonListener() {
  _renderGooglePayButtonListener = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e, response) {
    var _response$paymentMeth, _response$paymentMeth2, AdyenPaymentMethods, applicationInfo, adyenTranslations, button, googlePayConfig, googlePay, googlePayComponent;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _response$paymentMeth = response.paymentMethodsResponse, _response$paymentMeth2 = _response$paymentMeth === void 0 ? {} : _response$paymentMeth, AdyenPaymentMethods = _response$paymentMeth2.AdyenPaymentMethods, applicationInfo = _response$paymentMeth2.applicationInfo, adyenTranslations = _response$paymentMeth2.adyenTranslations, button = response.button;
          googlePayConfig = getPaymentMethodConfig(AdyenPaymentMethods, [GOOGLE_PAY, PAY_WITH_GOOGLE]);
          if (googlePayConfig) {
            _context.n = 1;
            break;
          }
          return _context.a(2);
        case 1:
          googlePay = new GooglePay(googlePayConfig, applicationInfo, adyenTranslations, false);
          _context.n = 2;
          return googlePay.getComponent();
        case 2:
          googlePayComponent = _context.v;
          googlePayComponent.mount(button);
        case 3:
          return _context.a(2);
      }
    }, _callee);
  }));
  return _renderGooglePayButtonListener.apply(this, arguments);
}
function renderAmazonPayButtonListener(_x3, _x4) {
  return _renderAmazonPayButtonListener.apply(this, arguments);
}
function _renderAmazonPayButtonListener() {
  _renderAmazonPayButtonListener = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e, response) {
    var _response$paymentMeth3, _response$paymentMeth4, AdyenPaymentMethods, applicationInfo, adyenTranslations, button, amazonPayConfig, amazonPay, amazonPayComponent;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _response$paymentMeth3 = response.paymentMethodsResponse, _response$paymentMeth4 = _response$paymentMeth3 === void 0 ? {} : _response$paymentMeth3, AdyenPaymentMethods = _response$paymentMeth4.AdyenPaymentMethods, applicationInfo = _response$paymentMeth4.applicationInfo, adyenTranslations = _response$paymentMeth4.adyenTranslations, button = response.button;
          amazonPayConfig = getPaymentMethodConfig(AdyenPaymentMethods, AMAZON_PAY);
          if (amazonPayConfig) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2);
        case 1:
          amazonPay = new AmazonPay(amazonPayConfig, applicationInfo, adyenTranslations);
          _context2.n = 2;
          return amazonPay.getComponent();
        case 2:
          amazonPayComponent = _context2.v;
          amazonPayComponent.mount(button);
        case 3:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return _renderAmazonPayButtonListener.apply(this, arguments);
}
function renderApplePayButtonListener(_x5, _x6) {
  return _renderApplePayButtonListener.apply(this, arguments);
}
function _renderApplePayButtonListener() {
  _renderApplePayButtonListener = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e, response) {
    var _response$paymentMeth5, _response$paymentMeth6, AdyenPaymentMethods, applicationInfo, adyenTranslations, button, applePayConfig, applePay, applePayComponent;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _response$paymentMeth5 = response.paymentMethodsResponse, _response$paymentMeth6 = _response$paymentMeth5 === void 0 ? {} : _response$paymentMeth5, AdyenPaymentMethods = _response$paymentMeth6.AdyenPaymentMethods, applicationInfo = _response$paymentMeth6.applicationInfo, adyenTranslations = _response$paymentMeth6.adyenTranslations, button = response.button;
          applePayConfig = getPaymentMethodConfig(AdyenPaymentMethods, APPLE_PAY);
          if (applePayConfig) {
            _context3.n = 1;
            break;
          }
          return _context3.a(2);
        case 1:
          applePay = new ApplePay(applePayConfig, applicationInfo, adyenTranslations, false);
          _context3.n = 2;
          return applePay.getComponent();
        case 2:
          applePayComponent = _context3.v;
          applePayComponent.mount(button);
        case 3:
          return _context3.a(2);
      }
    }, _callee3);
  }));
  return _renderApplePayButtonListener.apply(this, arguments);
}
function renderPayPalButtonListener(_x7, _x8) {
  return _renderPayPalButtonListener.apply(this, arguments);
}
function _renderPayPalButtonListener() {
  _renderPayPalButtonListener = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e, response) {
    var _response$paymentMeth7, _response$paymentMeth8, AdyenPaymentMethods, applicationInfo, adyenTranslations, button, paypalConfig, paypal, paypalComponent;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _response$paymentMeth7 = response.paymentMethodsResponse, _response$paymentMeth8 = _response$paymentMeth7 === void 0 ? {} : _response$paymentMeth7, AdyenPaymentMethods = _response$paymentMeth8.AdyenPaymentMethods, applicationInfo = _response$paymentMeth8.applicationInfo, adyenTranslations = _response$paymentMeth8.adyenTranslations, button = response.button;
          paypalConfig = getPaymentMethodConfig(AdyenPaymentMethods, PAYPAL);
          if (paypalConfig) {
            _context4.n = 1;
            break;
          }
          return _context4.a(2);
        case 1:
          paypal = new Paypal(paypalConfig, applicationInfo, adyenTranslations);
          _context4.n = 2;
          return paypal.getComponent();
        case 2:
          paypalComponent = _context4.v;
          paypalComponent.mount(button);
        case 3:
          return _context4.a(2);
      }
    }, _callee4);
  }));
  return _renderPayPalButtonListener.apply(this, arguments);
}
function renderExpressPaymentContainerListener(_x9, _x0) {
  return _renderExpressPaymentContainerListener.apply(this, arguments);
}
function _renderExpressPaymentContainerListener() {
  _renderExpressPaymentContainerListener = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(e, response) {
    var paymentMethodsResponse, $expressPaymentButtonsContainer, expressPaymentButtons;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          paymentMethodsResponse = response.paymentMethodsResponse;
          $expressPaymentButtonsContainer = document.getElementById('express-container');
          expressPaymentButtons = getExpressPaymentButtons(paymentMethodsResponse);
          $expressPaymentButtonsContainer.replaceChildren.apply($expressPaymentButtonsContainer, _toConsumableArray(expressPaymentButtons));
          expressPaymentButtons.forEach(function (button) {
            var expressType = button.getAttribute('data-method');
            $('body').trigger("cart:render".concat(expressType, "Button"), {
              paymentMethodsResponse: paymentMethodsResponse,
              button: button
            });
          });
        case 1:
          return _context5.a(2);
      }
    }, _callee5);
  }));
  return _renderExpressPaymentContainerListener.apply(this, arguments);
}
function renderPayPalButton() {
  var eventName = "cart:render".concat(PAYPAL, "Button");
  if (!hasEventListener(eventName)) {
    $('body').on(eventName, renderPayPalButtonListener);
  }
}
function renderApplePayButton() {
  var eventName = "cart:render".concat(APPLE_PAY, "Button");
  if (!hasEventListener(eventName)) {
    $('body').on(eventName, renderApplePayButtonListener);
  }
}
function renderAmazonPayButton() {
  var eventName = "cart:render".concat(AMAZON_PAY, "Button");
  if (!hasEventListener(eventName)) {
    $('body').on(eventName, renderAmazonPayButtonListener);
  }
}
function renderGooglePayButton() {
  var eventName = "cart:render".concat(GOOGLE_PAY, "Button");
  if (!hasEventListener(eventName)) {
    $('body').on(eventName, renderGooglePayButtonListener);
  }
}
function renderExpressPaymentContainer() {
  var eventName = 'cart:renderExpressPaymentContainer';
  if (!hasEventListener(eventName)) {
    $('body').on(eventName, renderExpressPaymentContainerListener);
  }
}
function init() {
  return _init.apply(this, arguments);
}
function _init() {
  _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
    var paymentMethodsResponse;
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.n) {
        case 0:
          if (!(window.areCartExpressPaymentsEnabled === 'true')) {
            _context7.n = 2;
            break;
          }
          _context7.n = 1;
          return getExpressPaymentMethods();
        case 1:
          paymentMethodsResponse = _context7.v;
          store.paymentMethodsResponse = paymentMethodsResponse;
          $(document).ready(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
            return _regenerator().w(function (_context6) {
              while (1) switch (_context6.n) {
                case 0:
                  $('body').trigger('cart:renderExpressPaymentContainer', {
                    paymentMethodsResponse: paymentMethodsResponse
                  });
                case 1:
                  return _context6.a(2);
              }
            }, _callee6);
          })));
        case 2:
          return _context7.a(2);
      }
    }, _callee7);
  }));
  return _init.apply(this, arguments);
}
module.exports = {
  renderExpressPaymentContainer: renderExpressPaymentContainer,
  renderPayPalButton: renderPayPalButton,
  renderApplePayButton: renderApplePayButton,
  renderGooglePayButton: renderGooglePayButton,
  renderAmazonPayButton: renderAmazonPayButton,
  init: init
};